// @flow
import { Layout } from 'antd';
import UsefulInfos from 'bil-front-commons/lib/components/UsefulInfos';
import { activateLuxtrustMobile } from 'bil-front-commons/lib/constants/BILComURL';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import BILLoader from '../../components/BILLoader/BILLoader';
import BILPageHeader from '../../components/BILPageHeader';
import LanguagePanel from '../../components/LanguagePanel/LanguagePanel';
import { LuxtrustFrame, LuxTrustFrameTop } from '../../components/LuxtrustFrame';
import { checkUserDevice, scrollToTop } from '../../hooks/useWindowDimensions';
import { getBilComLanguage, handleLanguageChange } from '../../utils/LanguageUtils';
import redirectTo from '../../utils/RedirectUtil';
import './index.less';

//// JS MAIN
const LuxtrustConnection = (props) => {

   useEffect(() => {
      scrollToTop();
   }, []);

   const { language, match, paymentInfo } = props;
   const [isLoading, setLoading] = useState(false);

   const { mode } = match.params;
   const bilComLanguage = getBilComLanguage(language);
   const frameUrl = window.PAYMENT_URL + '/luxtrust/' + language + '/' + mode + '/' + paymentInfo.paymentRef
   const isRunningOnMobile = checkUserDevice();

   if (!isLoading) {
      return (
         <Layout className="luxtrust-layout">
            <BILPageHeader
               setLoading={setLoading}
               {...props}
            />
            {isRunningOnMobile ? null :
               <LanguagePanel
                  right={true}
                  onLanguageChange={(lang) => handleLanguageChange(props, lang, setLoading)}
                  {...props}
               />}
            <div className="luxtrust-wrapper" 
               style={{maxWidth: isRunningOnMobile ? '400px' : '480px'}}>
               <div className="luxtrust-frame">
                  <LuxTrustFrameTop
                     mode={mode}
                     language={language}
                     onChangeConnection={() => handleChangeConnection(props, setLoading)}
                  />
                  <LuxtrustFrame
                     url={frameUrl}
                  />
                  <div className="luxtrust-frame__wrapper">
                     <div className="luxtrust-frame__mobile-link">
                        <a
                           href={activateLuxtrustMobile[bilComLanguage]}
                           target="_blank"
                           rel="noopener noreferrer">
                           <FormattedMessage id="iframe.how-to-activate-luxtrust-mobile" />
                        </a>
                     </div>
                     <div className="luxtrust-frame__recall-title">
                        <FormattedMessage id="luxtrust-security-recall-title" />
                     </div>
                     <div className="luxtrust-frame__recall-description">
                        <FormattedMessage id="luxtrust-security-recall-description" />
                     </div>
                  </div>
               </div>
               <UsefulInfos bilComLanguage={bilComLanguage} />
            </div>
         </Layout>
      )
   } else {
      return (
         <div className="intl-spinner-container">
            <BILLoader />
         </div>
      );
   }

}

//// JS FUNCTIONS
function handleChangeConnection(props, setLoading) {
   const { language, history } = props;
   setLoading(true);
   redirectTo(history, `/${language}/device`);
};

//// JS REDUX
const mapStateToProps = (state) => ({
   language: state.intl.locale,
   paymentInfo: state.paymentInfoParam.paymentInfo
});

export default connect(mapStateToProps)(LuxtrustConnection);
